import noop from 'lodash/noop'

import Button from 'app/shared-components/Button'

import useStyles from './SkyNetStepperButtons.styles'

type Props = {
    isValid: boolean,
    canGoBack?: boolean,
    canEdit?: boolean,
    isLoading?: boolean,
    disabled?: boolean,
    nextAction?: () => void,
    backAction?: () => void,
    editAction?: () => void,
    nextLabel?: string,
    backLabel?: string,
    customButtons?: JSX.Element[],
}

const defaultProps: Partial<Props> = {
    canGoBack: false,
    canEdit: false,
    disabled: false,
    isLoading: false,
    nextAction: undefined,
    backAction: noop,
    editAction: noop,
    nextLabel: undefined,
    backLabel: undefined,
    customButtons: [],
}

const SkyNetStepperButtons = ({
    isValid,
    canGoBack,
    disabled,
    nextAction,
    backAction,
    nextLabel,
    backLabel,
    canEdit,
    editAction,
    isLoading,
    customButtons,
}: Props) => {
    const {
        classes,
        cx,
    } = useStyles()

    return (
        <div className={cx(classes.buttonWrapper, classes.doubleButtons)}>
            {!canEdit && nextAction && (
                <Button
                    label={nextLabel || 'Next'}
                    onClick={nextAction}
                    className={classes.button}
                    disabled={disabled || !isValid}
                    saving={isLoading}
                />
            )}
            {canEdit && (
                <Button
                    label="Edit"
                    onClick={editAction}
                    className={classes.button}
                    data-testid="btn-edit"
                />
            )}
            {customButtons.map((el) => {
                return el
            })}
            {canGoBack && !canEdit && (
                <Button
                    label={backLabel || 'Back'}
                    secondary
                    onClick={backAction}
                    className={classes.button}
                    data-testid="btn-back"
                />
            )}
        </div>
    )
}

SkyNetStepperButtons.defaultProps = defaultProps

export default SkyNetStepperButtons
